"use client";

import { removeItem } from "@/lib/shopify/actions/cart";
import type { CartItem } from "lib/shopify/types";
import { X } from "lucide-react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

export function DeleteItemButton({
  item,
  optimisticUpdate,
}: {
  item: CartItem;
  optimisticUpdate: any;
}) {
  const router = useRouter();
  const merchandiseId = item.merchandise.id;

  return (
    <form
      action={async () => {
        optimisticUpdate(merchandiseId, "delete");
        const error = await removeItem(null, merchandiseId);
        if (error) toast.error(error);
        router.refresh();
      }}
    >
      <button
        type="submit"
        aria-label="Artikel entfernen"
        className="flex h-[2.25rem] w-[2.25rem] items-center justify-center rounded-full bg-[#1E3739] border border-white"
      >
        <X className="mx-[1px] h-8 w-8 text-white" />
      </button>
    </form>
  );
}
